export function getDataColor(pos, value, colorMap) {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c getDataColor', 'font-weight: bold; color: none',
            '\n' + ' - pos.typeof: ', typeof pos,
            '\n' + ' - value.typeof: ', typeof value,
            '\n' + ' - colorMap.typeof: ', typeof colorMap + '\n',
            { pos },
            { value },
            { colorMap }
        );
    }

    if (!value) {
        return "#00ffff";
    }

    let c = window.dw.utils.mappedColors.find(c => c.value === value.toString().toLowerCase().trim());

    if (c) {
        return c.color;
    }

    c = {
        value: value.toString().toLowerCase().trim(),
        color: colorMap[pos % 10]
    };

    window.dw.utils.mappedColors.push(c);

    return c.color;
}

export function getCustomMatchDataColor(value, colorMap) {

    // Console logging flag
    const logToConsole = false;

    // TODO: Make output a variable; move logging condition to bottom of function and log output too
    // Console logging
    if (logToConsole) {
        console.log(
            '%c getCustomMatchDataColor', 'font-weight: bold; color: none',
            '\n' + ' - value.typeof: ', typeof value,
            '\n' + ' - colorMap.typeof: ', typeof colorMap + '\n',
            { value },
            { colorMap }
        );
    }

    if (!value) {
        return "#00ffff";
    }

    let c = window.dw.utils.mappedColors.find(c => c.value === value.toString().toLowerCase().trim());

    if (c) {
        return c.color;
    }

    let color = colorMap.find(c => c.value.toString().toLowerCase().trim() === value.toString().toLowerCase().trim());

    // if no color found, default to #00ffff
    c = {
        value: value.toString().toLowerCase().trim(),
        color: color ? color.color : '#00ffff'
    };

    window.dw.utils.mappedColors.push(c);

    return c.color;
}

export function getRAGStyleProperty(value, condition) {

    // Console logging flag
    const logToConsole = false;

    let output = '';

    if (value && condition.value) {
        switch (value.toString().toLowerCase()) {
            // Add colors as appropriate
            // (R) Red
            case condition.value.hasOwnProperty('lightred') && condition.value.lightred.toString().toLowerCase():
                output = 'lightred';
                break;
            case condition.value.hasOwnProperty('lightmediumred') && condition.value.lightmediumred.toString().toLowerCase():
                output = 'lightmediumred';
                break;
            case condition.value.hasOwnProperty('red') && condition.value.red.toString().toLowerCase():
                output = 'red';
                break;
            case condition.value.hasOwnProperty('darkmediumred') && condition.value.darkmediumred.toString().toLowerCase():
                output = 'darkmediumred';
                break;
            case condition.value.hasOwnProperty('darkred') && condition.value.darkred.toString().toLowerCase():
                output = 'darkred';
                break;
            // (A) Amber
            case condition.value.hasOwnProperty('lightamber') && condition.value.lightamber.toString().toLowerCase():
                output = 'lightamber';
                break;
            case condition.value.hasOwnProperty('lightmediumamber') && condition.value.lightmediumamber.toString().toLowerCase():
                output = 'lightmediumamber';
                break;
            case condition.value.hasOwnProperty('amber') && condition.value.amber.toString().toLowerCase():
                output = 'amber';
                break;
            case condition.value.hasOwnProperty('darkmediumamber') && condition.value.darkmediumamber.toString().toLowerCase():
                output = 'darkmediumamber';
                break;
            case condition.value.hasOwnProperty('darkamber') && condition.value.darkamber.toString().toLowerCase():
                output = 'darkamber';
                break;
            // (G) Green
            case condition.value.hasOwnProperty('lightgreen') && condition.value.lightgreen.toString().toLowerCase():
                output = 'lightgreen';
                break;
            case condition.value.hasOwnProperty('lightmediumgreen') && condition.value.lightmediumgreen.toString().toLowerCase():
                output = 'lightmediumgreen';
                break;
            case condition.value.hasOwnProperty('green') && condition.value.green.toString().toLowerCase():
                output = 'green';
                break;
            case condition.value.hasOwnProperty('darkmediumgreen') && condition.value.darkmediumgreen.toString().toLowerCase():
                output = 'darkmediumgreen';
                break;
            case condition.value.hasOwnProperty('darkgreen') && condition.value.darkgreen.toString().toLowerCase():
                output = 'darkgreen';
                break;
            case condition.value.hasOwnProperty('noData') && condition.value.noData.toString().toLowerCase():
                output = 'noData';
                break;
            default:
                output = '';
        }
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getRAGStyleProperty', 'font-weight: bold; color: none',
            '\n' + ' - value.typeof: ', typeof value,
            '\n' + ' - condition.typeof: ', typeof condition,
            '\n' + ' - output.typeof:', typeof output + '\n',
            { value },
            { condition },
            { output }
        );
    }

    return output;
}

export function getRAGStyleValue(value, ragStyle) {

    // Console logging flag
    const logToConsole = false;

    let bkgColor = '';

    if (value) {
        switch(value.toLowerCase()) {
            // Add colors as appropriate
            // (R) Red
            case 'lightred':
                bkgColor = ragStyle.lightred;
                break;
            case 'lightmediumred':
                bkgColor = ragStyle.lightmediumred;
                break;
            case 'red':
                bkgColor = ragStyle.red;
                break;
            case 'darkmediumred':
                bkgColor = ragStyle.darkmediumred;
                break;
            case 'darkred':
                bkgColor = ragStyle.darkred;
                break;
            // (A) Amber
            case 'lightamber':
                bkgColor = ragStyle.lightamber;
                break;
            case 'lightmediumamber':
                bkgColor = ragStyle.lightmediumamber;
                break;
            case 'amber':
                bkgColor = ragStyle.amber;
                break;
            case 'darkmediumamber':
                bkgColor = ragStyle.darkmediumamber;
                break;
            case 'darkamber':
                bkgColor = ragStyle.darkamber;
                break;
            // (G) Green
            case 'lightgreen':
                bkgColor = ragStyle.lightgreen;
                break;
            case 'lightmediumgreen':
                bkgColor = ragStyle.lightmediumgreen;
                break;
            case 'green':
                bkgColor = ragStyle.green;
                break;
            case 'darkmediumgreen':
                bkgColor = ragStyle.darkmediumgreen;
                break;
            case 'darkgreen':
                bkgColor = ragStyle.darkgreen;
                break;
            case 'noData':
                bkgColor = ragStyle.noData;
                break;
            default:
                bkgColor = '';
        }
    }

    // Console logging
    if (logToConsole) {
        console.log(
            '%c getRAGStyleValue', 'font-weight: bold; color: none',
            '\n' + ' - value.typeof: ', typeof value,
            '\n' + ' - ragStyle.typeof: ', typeof ragStyle,
            '\n' + ' - bkgColor.typeof:', typeof bkgColor + '\n',
            { value },
            { ragStyle },
            { bkgColor }
        );
    }

    return bkgColor;
}